<template>
  <div class="mt-4 container d-flex justify-content-center align-items-center">
    <span class="poweredby-text">{{ $t('message.poweredBy') }}</span>
    <a
      href="https://abacus.co"
      alt="The iPad POS System you love"
      title="The iPad POS System you love"
      target="_blank"
      rel="noopener noreferrer"
    >
      <!--add rel=noopener noreferrer to this link to prevent the original page from being modified by the opened link-->
      <img class="poweredby-image" :src="logoUrl" alt="logo" />
    </a>
  </div>
</template>
<script>
import { wcconfig } from "../../../wcConfig";
export default {
  data() {
    return {
      logoUrl: ""
    };
  },
  created() {
    this.logoUrl = wcconfig.assets.abacus;
  }
};
</script>
